export default __webpack_public_path__ + "static/media/KumbhSans-Light.d6b50000.ttf";